// TermsCheckbox.js - GÜNCELLENMİŞ

import React from 'react';
import { FormGroup, Label, Input, UncontrolledTooltip } from 'reactstrap';

const TermsCheckbox = ({ checked, canCheck, hasReadContract, onChange, onOpenContract }) => {
    // Sözleşme kutucuğunun TIKLANABİLMEŞİ için gereken MANTIKAL koşul:
    // 1. Formun temel alanları geçerli olmalı (canCheck)
    // 2. Sözleşme metni modali açılıp sonuna kadar okunmuş olmalı (hasReadContract)
    const isActuallyCheckable = canCheck && hasReadContract;

    // Hata düzeltmesi: Input bileşeninde id="contractAccept" zaten kullanılıyordu.
    // Artık ipucu için dinamik bir id veriyoruz ve asıl id'yi sadece bir kez kullanıyoruz.
    const inputId = "contractAccept";
    const hintTargetId = "termsHint";

    return (
        <FormGroup className="mb-3">
            <div
                className="d-flex align-items-center"
                style={{
                    // Görsel olarak devre dışı bırakma (opacity/cursor) kaldırıldı.
                    cursor: 'default',
                    userSelect: 'none',
                    opacity: 1
                }}
            >
                {/* Kontrol Kutucuğu */}
                <Input
                    type="checkbox"
                    className="form-check-input me-2"
                    id={inputId} // Hatanın olduğu yer düzeltildi.
                    checked={checked}
                    // disabled niteliği kaldırıldı, böylece her zaman tıklanabilir görünecek.
                    // Tıklama mantığı (onChange) içinde kısıtlanacak.
                    // disabled={disabled} // KALDIRILDI
                    onChange={e => {
                        // Tikleme işlemini sadece MANTIKAL koşullar karşılanırsa gerçekleştir.
                        if (!isActuallyCheckable) return;
                        onChange(e.target.checked);
                    }}
                    style={{
                        margin: 0,
                        // Mantıksal olarak kısıtlıysa fare imlecini yasak işareti yap.
                        cursor: isActuallyCheckable ? 'pointer' : 'not-allowed'
                    }}
                    // İpucunu göstermek için kutucuğa bir hedef id tanımlıyoruz.
                    {...(!isActuallyCheckable && { id: hintTargetId + "Checkbox" })}
                />

                {/* Sözleşme Metni Etiketi */}
                <Label
                    className="form-check-label flex-grow-1"
                    htmlFor={inputId} // Asıl input ID'si
                    id="termsLabel"
                    onClick={onOpenContract} // Her zaman modalı açsın
                    style={{
                        color: '#0d6efd', // Her zaman aktif mavi renk
                        textDecoration: 'underline',
                        cursor: 'pointer', // Her zaman tıklanabilir
                        margin: 0
                    }}
                >
                    Online tahsilat sözleşmesini okudum ve kabul ediyorum.
                </Label>

                {/* İpucu - Kutucuk Mantıksal Olarak Tiklenemiyorsa Göster */}
                {!isActuallyCheckable && (
                    <>
                        {/* İpucu ikonu - ayrı bir hedef id kullanıyoruz */}
                        <span id={hintTargetId} className="ms-2 bx bx-info-circle" style={{ fontSize: 18, cursor: 'pointer' }} />

                        {/* Hem ikonu hem de kutucuğu hedefleyen ipuçları */}
                        <UncontrolledTooltip target={hintTargetId} placement="top">
                            {!canCheck
                                ? 'Tüm alanları doldurunuz'
                                : 'Sözleşmeyi açıp metnin sonuna kadar kaydırmadan onaylayamazsınız.'}
                        </UncontrolledTooltip>
                        <UncontrolledTooltip target={hintTargetId + "Checkbox"} placement="top">
                            {!canCheck
                                ? 'Tüm alanları doldurunuz'
                                : 'Sözleşmeyi açıp metnin sonuna kadar kaydırmadan onaylayamazsınız.'}
                        </UncontrolledTooltip>
                    </>
                )}
            </div>
        </FormGroup>
    );
};

export default TermsCheckbox;